import ShopEntity from '../../domain/entities/ShopEntity';

export class ShopDto {
    static fromJson(json: any): ShopEntity {
        return {
            id: json['id']?.toString() || '',
            name: json['name'] || '',
            address: json['address'],
        };
    }

    static toJson(shop: ShopEntity): any {
        return {
            id: shop.id,
            name: shop.name,
            address: shop.address,
        };
    }
}

export default ShopDto;
